var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrationFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "integration_fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16683 4.66667C3.62707 4.66667 4.00016 4.29357 4.00016 3.83333C4.00016 3.3731 3.62707 3 3.16683 3C2.70659 3 2.3335 3.3731 2.3335 3.83333C2.3335 4.29357 2.70659 4.66667 3.16683 4.66667Z",
    fill: "#307FE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0002 15.3333C13.9206 15.3333 14.6668 14.5871 14.6668 13.6667C14.6668 12.7462 13.9206 12 13.0002 12C12.0797 12 11.3335 12.7462 11.3335 13.6667C11.3335 14.5871 12.0797 15.3333 13.0002 15.3333Z",
    fill: "#307FE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6668 3.66667C13.4032 3.66667 14.0002 3.06971 14.0002 2.33333C14.0002 1.59695 13.4032 1 12.6668 1C11.9304 1 11.3335 1.59695 11.3335 2.33333C11.3335 3.06971 11.9304 3.66667 12.6668 3.66667Z",
    fill: "#307FE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66683 13.3333C3.40321 13.3333 4.00016 12.7364 4.00016 12C4.00016 11.2636 3.40321 10.6667 2.66683 10.6667C1.93045 10.6667 1.3335 11.2636 1.3335 12C1.3335 12.7364 1.93045 13.3333 2.66683 13.3333Z",
    fill: "#307FE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3335 10.6667C8.80625 10.6667 10.0002 9.47276 10.0002 8C10.0002 6.52724 8.80625 5.33333 7.3335 5.33333C5.86074 5.33333 4.66683 6.52724 4.66683 8C4.66683 9.47276 5.86074 10.6667 7.3335 10.6667Z",
    fill: "#307FE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46057 9.53954L3.70641 11.2938C3.59251 11.4077 3.40783 11.4077 3.29393 11.2938C3.18002 11.1799 3.18002 10.9952 3.29392 10.8813L5.04808 9.12707C5.16198 9.01317 5.34666 9.01316 5.46056 9.12706C5.57447 9.24096 5.57447 9.42564 5.46057 9.53954Z",
    fill: "#307FE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1088 3.53959L9.37311 6.27526C9.2592 6.38916 9.07453 6.38916 8.96063 6.27526C8.84672 6.16136 8.84673 5.97669 8.96063 5.86278L11.6963 3.12711C11.9623 2.86112 12.3748 3.2736 12.1088 3.53959Z",
    fill: "#307FE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.53974 4.12709C3.65364 4.01319 3.83832 4.01319 3.95222 4.1271L5.70637 5.88128C5.82027 5.99519 5.82027 6.17986 5.70636 6.29376C5.59246 6.40766 5.40779 6.40766 5.29388 6.29376L3.53973 4.53957C3.42583 4.42567 3.42583 4.24099 3.53974 4.12709Z",
    fill: "#307FE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7939 12.8729C11.68 12.9868 11.4953 12.9868 11.3814 12.8729L8.79392 10.2854C8.68002 10.1715 8.68002 9.98681 8.79392 9.87291C8.90783 9.759 9.0925 9.759 9.2064 9.87291L11.7939 12.4604C11.9078 12.5743 11.9078 12.759 11.7939 12.8729Z",
    fill: "#307FE2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationFill);
export default __webpack_public_path__ + "static/media/integration_fill.8840ccce4f9f3ad8f7dbb5aabbc1558e.svg";
export { ForwardRef as ReactComponent };